const getAssignmentClassroomIds = (assignmentClassrooms) => {
  return assignmentClassrooms.map((assignmentClassroom) => {
    return assignmentClassroom.classroom.id;
  });
};

const getClassroomsContentIsAssignedTo = (matchedAssignments) => {
  return matchedAssignments
    .map((assignment) => {
      return getAssignmentClassroomIds(assignment.assignment_classrooms);
    })
    .flat();
};

export default getClassroomsContentIsAssignedTo;
